import { render, staticRenderFns } from "./conversation-preserve.vue?vue&type=template&id=6b0edf22&scoped=true"
import script from "./conversation-preserve.vue?vue&type=script&lang=js"
export * from "./conversation-preserve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0edf22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b0edf22')) {
      api.createRecord('6b0edf22', component.options)
    } else {
      api.reload('6b0edf22', component.options)
    }
    module.hot.accept("./conversation-preserve.vue?vue&type=template&id=6b0edf22&scoped=true", function () {
      api.rerender('6b0edf22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/conversation-list/conversation-preserve.vue"
export default component.exports